module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-bb58e57c.woff";